import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, doc, onSnapshot, query, where, writeBatch, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../firebase";
export default function ReportPage() {
  const [rooms, setRooms] = useState([]),
    [roomId, setRoomId] = useState(""),
    [details, setDetails] = useState(""),
    [error, setError] = useState(""),
    [sending, setSending] = useState(false);
  const navigate = useNavigate(),
    uid = auth.currentUser?.uid;
  useEffect(() => {
    if (!uid) return;
    return onSnapshot(query(collection(db, "rooms"), where("members", "array-contains", uid)), snap => setRooms(snap.docs.map(d => ({
      id: d.id,
      ...d.data()
    })).filter(r => ["deposited", "shipped"].includes(r.status))), () => setError("โหลดรายการดีลไม่สำเร็จ"));
  }, [uid]);
  async function submit(e) {
    e.preventDefault();
    if (!roomId || !details.trim() || sending) return;
    setSending(true);
    setError("");
    try {
      const batch = writeBatch(db);
      batch.update(doc(db, "rooms", roomId), {
        status: "disputed"
      });
      batch.set(doc(collection(db, "rooms", roomId, "messages")), {
        type: "system",
        senderId: uid,
        text: `แจ้งข้อพิพาท: ${details.trim()}`,
        createdAt: serverTimestamp()
      });
      await batch.commit();
      navigate(`/chat/${roomId}`);
    } catch (_) {
      setError("แจ้งปัญหาไม่สำเร็จ กรุณาตรวจสอบสถานะดีลแล้วลองอีกครั้ง");
    }
    setSending(false);
  }
  return <section className="kl-info-page"><h1>แจ้งปัญหา</h1><p>แจ้งข้อพิพาทเกี่ยวกับดีลและให้ทีมงานตรวจสอบ</p><div className="kl-info-note" style={{
      margin: "0 0 24px"
    }}>กรุณาตรวจสอบข้อมูลและอธิบายปัญหาตามจริง พร้อมเก็บหลักฐานการซื้อขายไว้ในห้องดีล</div><div className="kl-info-grid"><form className="kl-info-card" onSubmit={submit}><h2>รายละเอียดปัญหา</h2>{error && <div className="error-msg" role="alert">{error}</div>}<label className="kl-field-label" htmlFor="report-room">เลือกดีล</label><select id="report-room" className="kl-field" value={roomId} onChange={e => setRoomId(e.target.value)} required><option value="">เลือกดีลที่ต้องการแจ้งปัญหา</option>{rooms.map(r => <option key={r.id} value={r.id}>{r.roomCode} • {r.itemName}</option>)}</select><label className="kl-field-label" htmlFor="report-details">อธิบายปัญหา</label><textarea id="report-details" className="kl-field" value={details} onChange={e => setDetails(e.target.value)} rows={6} maxLength={4000} required placeholder="เกิดปัญหาอะไร สินค้าไม่ตรงตามข้อตกลงอย่างไร..." /><p>แนบรูปภาพหลักฐานเพิ่มเติมได้ในห้องแชทหลังแจ้งปัญหา</p><button className="kl-primary-action" disabled={sending || !roomId || !details.trim()}>{sending ? "กำลังส่ง..." : "ส่งเรื่องให้ทีมงานตรวจสอบ"}</button></form><aside className="kl-info-card"><h2>ขั้นตอนการตรวจสอบ</h2><p>01 แจ้งปัญหาและรายละเอียดในดีล<br /><br />02 ทีมงานตรวจสอบบทสนทนาและหลักฐาน<br /><br />03 แจ้งผลและดำเนินการตามข้อสรุป</p><div className="kl-info-note">ระหว่างตรวจสอบ สถานะดีลจะเป็นข้อพิพาท ห้ามกดยืนยันรับสินค้าหากยังมีปัญหาค้างอยู่</div></aside></div></section>;
}
